import React, { useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import { Form } from 'antd';
import { Form as FinalForm } from 'react-final-form';
import { FieldArray } from 'react-final-form-arrays';
import arrayMutators from 'final-form-arrays'

import Drawer from 'components/Shared/Drawers';
import Button from 'components/Shared/Common/Button';
import ImporterLink from 'components/Shared/Common/ImporterLink';
import styled from 'styled-components';

import { LabelListManager } from 'components/Shared/Forms';
import { ButtonActions } from 'components/Shared/styles';
import CategoryTitle from 'components/Shared/Layout/CategoryTitle';
import Icon from 'components/Shared/Common/Icon';

const formatMessages = intl => ({
    drawerTitle: intl.formatMessage({
        id: 'drawer.invitations.title',
        defaultMessage: 'Importer des contacts'
    }),
    invitationInputLabel: intl.formatMessage({
        id: 'drawer.invitations.input.label',
        defaultMessage: 'Saisissez l\'adresse email'
    }),
    invitationInputCreateLabel: intl.formatMessage({
        id: 'drawer.invitations.input.createLabelText',
        defaultMessage: 'Ajouter'
    }),
    invitationInputPlaceholder: intl.formatMessage({
        id: 'drawer.invitations.input.placeholder',
        defaultMessage: 'name@nomdedomaine.com'
    }),
    invitationEmailValid: intl.formatMessage({
        id: 'drawer.invitations.input.noOptionsMessageText',
        defaultMessage: 'Entrer une adresse email valide'
    }),
    importButton: intl.formatMessage({
        id: 'drawer.button.importFile',
        defaultMessage: 'Importer depuis un CSV'
    })
});

const LinkContainer = styled.div`
    display: flex;
    justify-content: flex-end;
`;

const Invitations = ({
    intl,
    onClose = () => {},
    requestUploadContactFile,
    onSubmit = () => {},
    initialValues,
    validators: { email },
}) => {
    const i18n = useMemo(() => formatMessages(intl), [intl]);
    const handleChangeUpload = useCallback((files, change, emails) =>
        requestUploadContactFile(files, change, emails), [requestUploadContactFile]);

    return (
        <Drawer
            onClose={onClose}
            isOpen
            title={(
                <CategoryTitle
                    label={i18n.drawerTitle}
                    icon={<Icon size="xl" iconName="Send" />}
                />
            )}
            placement="left"
        >
            <FinalForm
                onSubmit={onSubmit}
                initialValues={initialValues.emails}
                mutators={arrayMutators}
            >
                {({ handleSubmit, pristine, submitting, form, values }) => (
                    <Form onSubmit={handleSubmit} layout="vertical">
                        <FieldArray
                            name="emails"
                            component={LabelListManager}
                            label={i18n.invitationInputLabel}
                            size="large"
                            placeholder={i18n.invitationInputPlaceholder}
                            noOptionsMessageText={i18n.invitationEmailValid}
                            validators={[email]}// for component itself
                            rules={[email]}// for FormItem
                        />

                        <LinkContainer>
                            <ImporterLink onChange={({ files }) => handleChangeUpload(files, form.change, values.emails)}>
                                {i18n.importButton}
                            </ImporterLink>
                        </LinkContainer>

                        <ButtonActions>
                            <Button
                                iconName="Check"
                                onClick={form.submit}
                                color="primary"
                                isDisabled={pristine || submitting}
                                size="lg"
                            />
                        </ButtonActions>
                    </Form>
                )}
            </FinalForm>
        </Drawer>
    );
}

Invitations.propTypes = {
    intl: PropTypes.any.isRequired,
    requestUploadContactFile: PropTypes.func.isRequired,
    validators: PropTypes.object.isRequired,
    onClose: PropTypes.func,
    onSubmit: PropTypes.func,
};

export default injectIntl(Invitations);
